import { useInView } from "react-intersection-observer";

export const Opinions = () => {
  const { ref, inView } = useInView({
    threshold: 0.05,
  });
  return (
    <div
      className={`opinions-section-wrapper ${inView ? `visible` : ``}`}
      ref={ref}
    >
      <p className="opinions-section-wrapper__title">OPINIE NASZYCH KLIENTÓW</p>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        fill="black"
        className="bi bi-facebook"
        viewBox="0 0 16 16"
      >
        <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
      </svg>
      <div className="opinions-wrapper">
        <div className="opinions-left">
          <div className="opinion">
            <p className="opinion__text">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptas
              eius eos eaque officia culpa, molestias magni autem quas
              blanditiis iure, ipsa praesentium voluptatem, eveniet ipsum est
              iste. Alias, reprehenderit eum?
            </p>
            <p className="opinion__date">Październik 2021</p>
          </div>
          <div className="opinion">
            <p className="opinion__text">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptas
              eius eos eaque officia culpa, molestias magni autem quas
              blanditiis iure, ipsa praesentium voluptatem, eveniet ipsum est
              iste. Alias, reprehenderit eum?
            </p>
            <p className="opinion__date">Październik 2021</p>
          </div>
          <div className="opinion">
            <p className="opinion__text">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptas
              eius eos eaque officia culpa, molestias magni autem quas
              blanditiis iure, ipsa praesentium voluptatem, eveniet ipsum est
              iste. Alias, reprehenderit eum?
            </p>
            <p className="opinion__date">Październik 2021</p>
          </div>
        </div>
        <div className="opinions-center">
          <div className="opinion">
            <p className="opinion__text">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptas
              eius eos eaque officia culpa, molestias magni autem quas
              blanditiis iure, ipsa praesentium voluptatem, eveniet ipsum est
              iste. Alias, reprehenderit eum?
            </p>
            <p className="opinion__date">Październik 2021</p>
          </div>
          <div className="opinion">
            <p className="opinion__text">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptas
              eius eos eaque officia culpa, molestias magni autem quas
              blanditiis iure, ipsa praesentium voluptatem, eveniet ipsum est
              iste. Alias, reprehenderit eum?
            </p>
            <p className="opinion__date">Październik 2021</p>
          </div>
          <div className="opinion">
            <p className="opinion__text">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptas
              eius eos eaque officia culpa, molestias magni autem quas
              blanditiis iure, ipsa praesentium voluptatem, eveniet ipsum est
              iste. Alias, reprehenderit eum?
            </p>
            <p className="opinion__date">Październik 2021</p>
          </div>
        </div>
        <div className="opinions-right">
          <div className="opinion">
            <p className="opinion__text">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptas
              eius eos eaque officia culpa, molestias magni autem quas
              blanditiis iure, ipsa praesentium voluptatem, eveniet ipsum est
              iste. Alias, reprehenderit eum?
            </p>
            <p className="opinion__date">Październik 2021</p>
          </div>
          <div className="opinion">
            <p className="opinion__text">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptas
              eius eos eaque officia culpa, molestias magni autem quas
              blanditiis iure, ipsa praesentium voluptatem, eveniet ipsum est
              iste. Alias, reprehenderit eum?
            </p>
            <p className="opinion__date">Październik 2021</p>
          </div>
          <div className="opinion">
            <p className="opinion__text">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptas
              eius eos eaque officia culpa, molestias magni autem quas
              blanditiis iure, ipsa praesentium voluptatem, eveniet ipsum est
              iste. Alias, reprehenderit eum?
            </p>
            <p className="opinion__date">Październik 2021</p>
          </div>
        </div>
      </div>
    </div>
  );
};
